import React, { useContext } from "react";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { BOOST_DATA_QUERY } from "components/Pages/CustomerSupport/BoostSubscriptionManager/query";
import { ModalContext } from "components/common";

export const DOWNGRADE_BOOST_SUBSCRIPTION = gql`
  mutation DowngradeBoostSubscription($input: DowngradeBoostSubscriptionInput) {
    downgradeBoostSubscription(input: $input) {
      status
      code
      message
      display_message
    }
  }
`;

/**
 * @param {Object} props
 * @param {string} props.email - (Required) Email associated with subscription
 * @param {Date} props.selectedTier - (Required) Selected tier to downgrade to
 * @param {Date} props.selectedTerm - (Required) Selected term to downgrade to
 * @param {Date} props.endOfBillingCycle - (Required) End of current billing cycle
 * @param {string} props.subscriptionStatus - (Required) Stripe subscription status
 * @returns {React.ReactNode}
 */
const DowngradeBoostSubscriptionModal = (props) => {
  const {
    email,
    selectedTier,
    selectedTerm,
    subscriptionStatus,
    endOfBillingCycle,
  } = props;
  const { closeModal } = useContext(ModalContext);
  const [downgradeSubscription, { loading, error }] = useMutation(
    DOWNGRADE_BOOST_SUBSCRIPTION,
    {
      variables: { input: { tier: selectedTier, term: selectedTerm, email } },
      onCompleted: closeModal,
      refetchQueries: [{ query: BOOST_DATA_QUERY, variables: { email } }],
    }
  );
  const errorMessage =
    error?.graphQLErrors?.length > 0 ? error.graphQLErrors[0].message : "";

  return (
    <div
      style={{ backgroundColor: "#FAFAFA" }}
      className="py-8 px-12 flex flex-col max-w-2xl"
    >
      <h1>Confirm Downgrade</h1>
      {/* at this point subscriptionStatus is either active | past_due */}
      <p className="my-2">
        {subscriptionStatus === "active"
          ? <>
            <span>Subscription will be scheduled for downgrade on:</span>
            <div className="font-bold text-center text-lg">{`${endOfBillingCycle.toDateString()}`}</div>
          </>
          : "Subscription will be cancelled immediately"}
      </p>
      <button
        type="button"
        className="btn-green text-white px-3 py-1 mt-4"
        onClick={downgradeSubscription}
      >
        {loading ? "Downgrading..." : "Downgrade"}
      </button>
      <p className="mt-1 text-red-500">{errorMessage}</p>
    </div>
  );
};

export default DowngradeBoostSubscriptionModal;
